import { render, staticRenderFns } from "./VSLSectionRowRenderer.vue?vue&type=template&id=b3a5c084&scoped=true"
import script from "./VSLSectionRowRenderer.vue?vue&type=script&lang=js"
export * from "./VSLSectionRowRenderer.vue?vue&type=script&lang=js"
import style0 from "./VSLSectionRowRenderer.vue?vue&type=style&index=0&id=b3a5c084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a5c084",
  null
  
)

export default component.exports